import { createEntityAdapter, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import dayjs from 'dayjs';
import * as Sentry from "@sentry/react";
import { server } from "../staticData/staticData";
const reportAdapter=createEntityAdapter();
const initialState=reportAdapter.getInitialState({
    entities:{
        currReport:{
        date:"",
        site: "",
        driver: "",
        driverId:"",
        deliveryDay:"",
        run:"",
        departureTime:"",
        vehicle:"",
        vehicleNote:"Vehicle temperatures must be less than or equal to 5 degrees C.",
        alertTemp:"Please notify your State Manager if temperatures are >5 degrees C.",
        temperatureDeparture:"",
        temperatureAt2H:"",
        temperatureAt4H:"",
        temperatureAt6H:"",
        comment:"",
        temperatureAtEndShift:""
    }
    }
});
const serverURL=server
export const getReportByIdShortUrl=createAsyncThunk('report/getreportbyidshorturl', async ({reportId})=>{
    try {
        const response=await axios.get(serverURL+"drivertempcheck/report/id/"+reportId)    
        return response.data;
    } catch (error) {
        Sentry.captureException(error);
        Sentry.captureMessage("Error getReportByIdShortUrl:"+reportId);
    }
    
})
export const getReportById=createAsyncThunk('report/getreportbyid', async ({date,driverId,token})=>{
    const config={
        headers: {'driverId': `${driverId}`}
    }
    try {
        const response=await axios.get(serverURL+"drivertempcheck/report/"+date+"/"+driverId,config);
        return response.data;
    } catch (error) {
        Sentry.captureException(error)
        Sentry.captureMessage("Error getReportById:"+date+", driverId:"+driverId)
    }
})
export const getListReport=createAsyncThunk('report/getlistreport', async ({day, site, runId, driverId, token})=>{
    const config={
        headers: {'driverId': `${driverId}`}
    }
    try {
        const response=await axios.get(serverURL+"drivertempcheck/report?&driverId="+driverId,config);
        return response.data;        
    } catch (error) {
        Sentry.captureException(error)
        Sentry.captureMessage("Error getListReport driverId:"+driverId)
    }
})
export const createNewReport=createAsyncThunk('report/createnewreport', async ({data,driverId})=>{
    const config={
        headers: {'driverId': `${driverId}`}
    }
    data.version="1";
    data.company="thefruitbox"
    try {
        const response=await axios.post(serverURL+"drivertempcheck/report/",data,config);
        return response.data;        
    } catch (error) {
        Sentry.captureException(error)
        Sentry.captureMessage("Eror CreateNewReport driverId:"+driverId+" data:"+JSON.stringify(data))
        return error
    }
})
export const updateNewReport=createAsyncThunk('report/updatenewreport', async ({data, driverId})=>{
    const config={
        headers: {'driverId': `${driverId}`}
    }
    try {
        data.version="1";
        data.company="thefruitbox"
        const response=await axios.put(serverURL+"drivertempcheck/report/"+data.date+"/"+data.driverId,data,config);
        return response.data;
        
    } catch (error) {
        Sentry.captureException(error)
        Sentry.captureMessage("Error UpdateNewReport, driverId: "+driverId+", data:"+JSON.stringify(data))
        return error
    }
})
const reportSlice=createSlice({
    name:'report',
    initialState,
    reducers:{
        resetReportState:(state)=>state=initialState,
        resetReportNavigation:(state)=>{state.entities.reportNavigation={}}
    },
    extraReducers: (builder)=>{
        builder.addCase(getReportByIdShortUrl.fulfilled, (state, action)=>{
            state.status="success"
            state.entities.currReport=action.payload;
        })
        .addCase(getReportById.fulfilled,(state,action)=>{
            state.status="success"
            state.entities.currReport=action.payload;
            state.entities.currReport.deliveryDate=dayjs(dayjs(action.payload.deliveryDate).format("YYYY-MM-DD").toString()+"T00:00:00.000Z").toISOString();
        })
        .addCase(getReportById.pending, (state,action)=>{
            state.status="pending"
        })
        .addCase(getReportById.rejected, (state,action)=>{
            state.status="idle"
        })
        .addCase(createNewReport.fulfilled,(state, action)=>{
            state.status="success"
            if(action.payload.name && action.payload.name.toLowerCase().includes("error")){
                state.entities.error=action.payload.name
            }
            else{
                state.entities.reportNavigation=action.payload.data
                state.entities.error=""
            }

        })
        .addCase(createNewReport.pending,(state, action)=>{
            state.status="pending"
        })
        .addCase(createNewReport.rejected,(state, action)=>{
            state.status="idle"
        })
        .addCase(getListReport.fulfilled,(state,action)=>{
            state.status="success"
            state.entities.reportList=action.payload
        })
        .addCase(getListReport.pending,(state,action)=>{
            state.status="pending"
        })
        .addCase(getListReport.rejected,(state,action)=>{
            state.status="idle"
        })
        .addCase(updateNewReport.fulfilled,(state, action)=>{
            state.status="success"
            if(action.payload.name && action.payload.name.toLowerCase().includes("error")){
                state.entities.error=action.payload.name
            }
            else{
                state.entities.error=""
            }
        })
        .addCase(updateNewReport.pending,(state, action)=>{
            state.status="pending"
        })
        .addCase(updateNewReport.rejected,(state, action)=>{
            state.status="idle"
        })
    }
})
export default reportSlice.reducer;
export const {resetReportState, resetReportNavigation}=reportSlice.actions;